/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global lng */

function FormExportPdfBuilder() {
  if (!this instanceof FormExportPdfBuilder) return new FormExportPdfBuilder();

  var that = this;

  this.node;
  this.formSchema;

  this.loadFormSchema = loadFormSchema;
  this.load = load;
  this.getJson = getJson;
  this.onclose = (json) => console.warn("onclose() should be overwriten");
  this.oncancel = () => console.warn("oncancel() should be overwriten");

  this.node = document.createElement("div");
  this.node.classList.add("formExportCsv-builder");
  this.node.insertAdjacentHTML(
    "beforeend",
    `
        <div class="export">
            <div class="control-bar">
                <i class="ok material-icons">save</i>
                <i class="close material-icons">close</i>
                <h3>${lng.get("csvform-export-configuration")}</h3>
                <i class="delete material-icons">delete</i>
            </div>
            <div class="export-content">

            </div>
        </div>
        <div class="blueprints">
            <div class="control-bar">
                <h3>${lng.get("csvform-export-preform")}</h3>
            </div>
        </div>
    `
  );

  /**
   * @type Element
   */
  var exportLis2 = this.node.querySelector("div.export");
  var exportLis = this.node.querySelector("div.export-content");
  /**
   * @type Element
   */
  var blueprints = this.node.querySelector(".blueprints");
  /**
   * @type Element
   */
  var deleteArea = this.node.querySelector(".delete");

  var saveButton = this.node.querySelector("i.ok");
  var cancelButton = this.node.querySelector("i.close");

  //init drag & drop

  exportLis.data = {
    inDrag: null,
  };
  exportLis2.addEventListener("dragover", function (e) {
    e.preventDefault();

    //remove all flags
    var flaged = this.querySelectorAll(".input.insert-before");
    for (var i = 0, len = flaged.length; i < len; i++)
      flaged[i].classList.remove("insert-before");

    //highlight the remove area
    if (e.target === deleteArea) deleteArea.classList.add("highlight");
    else deleteArea.classList.remove("highlight");

    //search for other input
    var target = e.target;
    while (target !== this) {
      if (target.classList.contains("input")) break;
      target = target.parentNode;
    }
    if (target === this) return;

    //highlight the input under the cursor
    target.classList.add("insert-before");
  });
  exportLis2.addEventListener("drop", function (e) {
    e.preventDefault();

    const text = e.dataTransfer.getData("text");
    const key = e.dataTransfer.getData("key");
    const type = e.dataTransfer.getData("type");
    const defaultInputType = e.dataTransfer.getData("defaultInputType");

    let object = null;

    if (e.dataTransfer.getData("object")) {
      object = JSON.parse(e.dataTransfer.getData("object"));
    }

    const newLi =
      exportLis.data.inDrag ||
      genSchemaItemNode(text, key, type, null, object, defaultInputType);

    deleteArea.classList.remove("highlight");
    if (e.target === deleteArea) {
      if (newLi.parentNode) newLi.parentNode.removeChild(newLi);
      return;
    }

    //get flagged
    var flagged = this.querySelector(".input.insert-before");
    if (!flagged) {
      exportLis.appendChild(newLi);
      return;
    }

    flagged.classList.remove("insert-before");
    exportLis.insertBefore(newLi, flagged);
  });

  cancelButton.addEventListener("click", function (e) {
    that.node.parentNode.removeChild(that.node);
    that.oncancel();
  });
  deleteArea.addEventListener(`click`, function (e) {
    console.log("deletebuttonpress");
  });
  saveButton.addEventListener(`click`, function (e) {
    var data = getJson();
    that.onclose(data);
    that.node.parentNode.removeChild(that.node);
  });

  /**
   *
   * @param {string} schema
   * @returns {undefined}
   */
  function loadFormSchema(schema) {
    schema = JSON.parse(schema);
    that.formSchema = schema;
    var nodes = [];

    FormExportPdfBuilder.reserved.map((r) =>
      nodes.push(genSchemaItemNode("", r, r, null, null))
    );

    schema.map((schemaItem) => {
      switch (schemaItem.type) {
        case "hr":
          //ignore
          return;
        case "image":
          var key = schemaItem.meta.name;
          nodes.push(
            genSchemaItemNode(
              keyToLabel(key),
              key,
              schemaItem.type,
              null,
              schemaItem
            )
          );
          break;
        case "sign":
          var key = schemaItem.meta.name;
          nodes.push(
            genSchemaItemNode(
              keyToLabel(key),
              key,
              schemaItem.type,
              null,
              schemaItem
            )
          );
          break;
        case "text":
          var key = schemaItem.meta.name;
          nodes.push(
            genSchemaItemNode(
              keyToLabel(key),
              key,
              schemaItem.type,
              null,
              schemaItem
            )
          );
          break;
        case "textArea":
          var key = schemaItem.meta.name;
          nodes.push(
            genSchemaItemNode(
              keyToLabel(key),
              key,
              schemaItem.type,
              null,
              schemaItem
            )
          );
          break;
        case "multichoice":
          var key = schemaItem.meta.name;
          nodes.push(
            genSchemaItemNode(
              keyToLabel(key),
              key,
              schemaItem.type,
              null,
              schemaItem
            )
          );
          break;
        case "raffle":
          var key = schemaItem.meta.name;
          nodes.push(
            genSchemaItemNode(
              keyToLabel(key),
              key,
              schemaItem.type,
              null,
              schemaItem
            )
          );
          break;
        case "tel":
          var telKeys = ["mobiletel", "festtel"];
          if (schemaItem.meta.vorwahl)
            telKeys = ["vwmobile", "mobiletel", "vwfest", "festtel"];
          telKeys.map((telKey) => {
            var key = schemaItem.meta.name + "." + telKey;
            nodes.push(
              genSchemaItemNode(
                keyToLabel(key),
                key,
                schemaItem.type,
                null,
                schemaItem
              )
            );
          });
          break;
        case "address":
          var addressKeys = [
            "postalCode",
            "city",
            "street",
            "houseNumber",
            "houseNumberExtra",
          ];
          if (schemaItem.meta.epaper)
            addressKeys = [
              "postalCode",
              "city",
              "street",
              "houseNumber",
              "houseNumberExtra",
              "print",
              "epaper",
            ];
          addressKeys.map((addrKey) => {
            var key = schemaItem.meta.name + "." + addrKey;
            nodes.push(
              genSchemaItemNode(
                keyToLabel(key), //example: Zustelladresse: Hausnummer
                key,
                schemaItem.type,
                null,
                schemaItem
              )
            ); //example: deliveryAddress.houseNumber
          });
          break;
        case "default":
          schemaItem.data.map((defaultItem) => {
            var key = schemaItem.meta.name + "." + defaultItem.name;
            nodes.push(
              genSchemaItemNode(
                keyToLabel(key), //example: Name: Vorname
                key,
                schemaItem.type,
                null,
                schemaItem,
                defaultItem.type
              )
            ); //example: name.firstname
          });
          break;
        default:
          console.error(`Type ${schemaItem.type} not implemented`);
      }
    });

    requestAnimationFrame(() => {
      nodes.map((n) => {
        n.classList.add("blueprint");
        n.classList.add("item");
        blueprints.appendChild(n);
      });
    });
  }

  function load(data) {
    data = JSON.parse(data);

    const nodes = [];

    data.map((i) => {
      nodes.push(
        genSchemaItemNode(
          keyToLabel(i.key),
          i.key,
          i.type,
          i.function,
          i,
          i.defaultInputType
        )
      );
    });

    requestAnimationFrame(() => {
      nodes.map((i) => exportLis.appendChild(i));
    });
  }

  function getJson() {
    let labels = exportLis.querySelectorAll("label:first-of-type");
    labels = Array.from(labels);

    var data = labels.reduce(function (result, i) {
      switch (i.key) {
        case undefined:
          break;
        default:
          let functionsCount = i.functionsCount;
          let defaultInputType = i.defaultInputType;

          const data = {
            key: i.key,
            label: i.textContent,
            type: i.type,
            functionsCount: functionsCount,
          };

          if (defaultInputType) {
            data.defaultInputType = defaultInputType;
          }

          const functionSelect =
            i.parentElement.parentElement.querySelector(".function-select");
          if (functionSelect && functionSelect.selectedIndex > 0) {
            if (functionSelect.selectedIndex > 0) {
              let selectedFunction =
                functionSelect.options[functionSelect.selectedIndex].value;
              if (selectedFunction) {
                data.function = selectedFunction;

                let dynamicFunctionValueInput =
                  i.parentNode.parentNode.parentNode.querySelector(
                    "#dynamicFunctionValue"
                  );
                if (dynamicFunctionValueInput) {
                  data.dynamicFunctionValue = dynamicFunctionValueInput.value;
                }
              }
            }
          }

          result.push(data);
      }
      return result;
    }, []);
    return JSON.stringify(data);
  }

  /**
   * Generate a draggable node.
   * @param {string} text for label
   * @param {string} key key pattern to identify in form
   * use <i>empty</i> to create a spacer column.
   * For 'key=empty'
   * * @param type
   * * @param functionValue
   * * @param object
   * * @param defaultInputType
   * * @returns {Element}
   */
  function genSchemaItemNode(
    text,
    key,
    type,
    functionValue,
    object,
    defaultInputType
  ) {
    const schemaNode = createSchemaNode(text, key);
    schemaNode.type = type;
    schemaNode.object = object;

    let functions = getFunctionsForType(type, object, key);

    if (defaultInputType && defaultInputType === "tel") {
      functions = getFunctionsForType(defaultInputType, object, key);
    } else {
      defaultInputType = null;
    }

    if (
      object &&
      object.type === "text" &&
      object.meta &&
      object.meta.checkbox === false
    )
      // Don't show the functions of the text element if no checkbox is visible
      functions = [];

    if (
      object &&
      object.functionsCount !== null &&
      object.functionsCount === 0 &&
      functions.length > 0
    ) {
      // Loaded elements from the API return the functionCount
      functions = [];
    }

    if (
      object &&
      object.type === "raffle" &&
      object.data &&
      object.data.text2 !== undefined
    ) {
      // raffle elements with more than one answer can't use the X function
      functions = [];
    }

    schemaNode.insertAdjacentHTML(
      "beforeend",
      `
            <tr>
                <td colspan=2 class="labels">
                <td colspan=14 class="functions">
                </td>
            </tr>
        `
    );
    let label = document.createElement("label");

    label.textContent = text;
    label.key = key;
    label.type = type;
    label.functionsCount = functions.length;
    label.defaultInputType = defaultInputType;

    if (FormExportPdfBuilder.reserved.indexOf(key) !== -1) {
      label.textContent = lng.get("formExport-reserved_" + key);
    }

    const labelInput = schemaNode.querySelector(".labels");
    labelInput.appendChild(label);

    if (functions.length > 0) {
      const functionsElement = schemaNode.querySelector(".functions");
      let functionSelect = document.createElement("select");
      functionSelect.classList.add("function-select");

      const defaultOption = document.createElement("option");
      defaultOption.value = null;
      defaultOption.textContent = "Keine Funktion verwenden";
      functionSelect.appendChild(defaultOption);

      functions.map((f) => {
        const option = document.createElement("option");
        option.value = f.function;
        option.textContent = f.name;
        functionSelect.appendChild(option);
      });

      functionSelect.addEventListener("change", (event) => {
        let selectedValue =
          functionSelect.options[functionSelect.selectedIndex].value;

        if (selectedValue === "dynamicFunctionValue") {
          const functionNameInput = document.createElement("input");
          functionNameInput.id = "dynamicFunctionValue";
          functionsElement.appendChild(functionNameInput);
        } else {
          const functionNameInput = functionsElement.querySelector(
            "#dynamicFunctionValue"
          );
          if (functionNameInput) {
            functionNameInput.parentElement.removeChild(functionNameInput);
          }
        }
      });

      let functionLabel = document.createElement("label");
      functionLabel.textContent = "Funktion";
      functionsElement.appendChild(functionLabel);
      functionsElement.appendChild(functionSelect);

      if (functionValue) {
        let selectedIndex =
          functions.findIndex((func) => func.function === functionValue) + 1;
        functionSelect.selectedIndex = selectedIndex;

        let selectedValue = functionSelect.options[selectedIndex].value;

        if (selectedValue === "dynamicFunctionValue") {
          const functionNameInput = document.createElement("input");
          functionNameInput.id = "dynamicFunctionValue";
          functionsElement.appendChild(functionNameInput);
          functionNameInput.value = object.dynamicFunctionValue;
        }
      }
    }

    schemaNode.addEventListener("dragstart", function (e) {
      e.dataTransfer.setData("text", text);
      e.dataTransfer.setData("key", key);
      e.dataTransfer.setData("type", type);

      if (defaultInputType) {
        e.dataTransfer.setData("defaultInputType", defaultInputType);
      }

      if (object && (object.type || object.key)) {
        e.dataTransfer.setData("object", JSON.stringify(object));
      }

      // if node is not inside the blueprint wrapper, tell the form which node is currently draging
      if (!this.classList.contains("blueprint")) exportLis.data.inDrag = this;
    });
    schemaNode.addEventListener("dragend", function (e) {
      exportLis.data.inDrag = null;
    });

    return schemaNode;
  }

  function keyToLabel(key) {
    var schema = that.formSchema;
    var keyParts = key.split("."); //currently max length is 2

    var schemaItem;

    for (let i = 0, len = schema.length; i < len; i++) {
      var item = schema[i];
      if (item.meta.name === keyParts[0]) {
        schemaItem = item;
        break;
      }
    }

    if (!schemaItem) return;

    switch (schemaItem.type) {
      case "image":
        return lng.get("formExport-image") + ":" + schemaItem.meta.name;
      case "sign":
        return lng.get("formExport-sign") + ":" + schemaItem.meta.name;
      case "raffle":
      case "multichoice":
      case "textArea":
      case "text":
        return schemaItem.meta.name;
      case "address":
        var addressKey = keyParts[1];
        if (schemaItem.meta.label)
          return (
            schemaItem.meta.label +
            ": " +
            lng.get("form-input-address-" + addressKey)
          );
        return lng.get("form-input-address-" + addressKey);
      case "tel":
        var telKey = keyParts[1];
        if (schemaItem.meta.name)
          return (
            schemaItem.meta.name + ": " + lng.get("form-input-tel-" + telKey)
          );
        return lng.get("form-input-tel-" + telKey);
      case "default":
        var secondKey = keyParts[1];
        var defaultData = schemaItem.data;
        for (var i = 0, len = defaultData.length; i < len; i++) {
          var defaultItem = defaultData[i];
          if (defaultItem.name === secondKey) {
            if (schemaItem.meta.name)
              return schemaItem.meta.name + ": " + defaultItem.name;
            return defaultItem.name;
          }
        }
        break;
      default:
        console.error(`Type ${schemaItem.type} not implemented`);
    }
  }
}

Object.defineProperty(FormExportPdfBuilder, "reserved", {
  //Important!! Sync this with CustomerService.js
  value: [
    "partnerGroup",
    "partner",
    "form",
    "location",
    "marketnumber",
    "employee",
    "employeenumber",
    "date",
    "customerid",
    "customerid_intern",
    "iban",
    "delivery_end",
  ],
});
